import { render, staticRenderFns } from "./AnnualAdd.vue?vue&type=template&id=55168710&scoped=true&"
import script from "./AnnualAdd.vue?vue&type=script&lang=js&"
export * from "./AnnualAdd.vue?vue&type=script&lang=js&"
import style0 from "./AnnualAdd.vue?vue&type=style&index=0&id=55168710&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55168710",
  null
  
)

export default component.exports